export var throwIfNotAFunction = function (func, errorMsg) {
    if (errorMsg === void 0) { errorMsg = "Is not a function"; }
    if (typeof func !== "function") {
        throw new Error(errorMsg);
    }
};
